import { render, staticRenderFns } from "./PhraseDetails.vue?vue&type=template&id=6de4afde&scoped=true&"
import script from "./PhraseDetails.vue?vue&type=script&lang=js&"
export * from "./PhraseDetails.vue?vue&type=script&lang=js&"
import style0 from "./PhraseDetails.vue?vue&type=style&index=0&id=6de4afde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de4afde",
  null
  
)

component.options.__file = "PhraseDetails.vue"
export default component.exports